import { PRODUCT } from './PageType';

export const ONBOARDING_ROOT = '/account';

export const REGISTRATION = {
  [PRODUCT.HELOC]: `${ONBOARDING_ROOT}/heloc/register`,
  [PRODUCT.SLR]: `${ONBOARDING_ROOT}/slr/applications/register`,
  [PRODUCT.MORTGAGE_REFI]: `${ONBOARDING_ROOT}/cash-out-refinance/applications/start`,
};
